export default __webpack_public_path__ + "static/media/realestate-surface.dee182bb.svg";